import SubcategoryPage from '@/components/template/SubcategoryPage';

const VeloceStool = () => {
  const products = [
    {
      title: "Veloce Stool Classic",
      imageSrc: "https://images.unsplash.com/photo-1588866413115-47473525bfc4?auto=format&fit=crop&q=80",
      url: "/proizvodi/veloce-stool-classic"
    },
    {
      title: "Veloce Stool Modern",
      imageSrc: "https://images.unsplash.com/photo-1579656381253-c2e57a7d7c81?auto=format&fit=crop&q=80",
      url: "/proizvodi/veloce-stool-modern"
    },
    {
      title: "Veloce Stool Compact",
      imageSrc: "https://images.unsplash.com/photo-1562663474-6cbb3eaa4d14?auto=format&fit=crop&q=80",
      url: "/proizvodi/veloce-stool-compact"
    }
  ];

  return (
    <SubcategoryPage
      title="Veloce Stool"
      description="Udobni in funkcionalni stoli Veloce, ki se prilagodijo vašemu življenjskemu slogu in potrebam."
      heroImage="https://images.unsplash.com/photo-1588866413115-47473525bfc4?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default VeloceStool;